import ImportHistoryDataCollection from 'modules/universal_importer/components/ImportHistoryDataCollection'

const SettingsPage = () => <ImportHistoryDataCollection />

export default SettingsPage
